import type { FeedbackTranslations } from "@jti/fe-common/config";

import { ContentFeedbackStatus } from "@/constants/feedback/contentFeedbackStatus";

export const getFeedbackQuestion = ({
  isUserLoggedIn,
  feedbackTranslations,
}: {
  isUserLoggedIn: boolean;
  feedbackTranslations: FeedbackTranslations;
}): string | undefined => (isUserLoggedIn ? feedbackTranslations.wasItHelpful : feedbackTranslations.loginText);

export const getFeedbackStatusMessage = ({
  status,
  feedbackTranslations,
}: {
  status: ContentFeedbackStatus;
  feedbackTranslations: FeedbackTranslations;
}): string | undefined => {
  const statusMessageByStatus: Partial<Record<ContentFeedbackStatus, string | undefined>> = {
    [ContentFeedbackStatus.LimitReached]: feedbackTranslations.limitReached,
    [ContentFeedbackStatus.JustLimitReached]:
      feedbackTranslations.justLimitReached ?? feedbackTranslations.limitReached,
    [ContentFeedbackStatus.Submitted]: feedbackTranslations.feedbackSubmitted,
  };

  return statusMessageByStatus[status];
};

export const getSubmittedFeedbackContent = (feedbackTranslations: FeedbackTranslations) => ({
  submittedMessage: feedbackTranslations.thanksForFeedback,
  submittedRewardHtml: feedbackTranslations.feedbackMechanismReward,
});
